





























































import { Vue, Component, Watch } from 'vue-property-decorator';
import ListItem from '../components/ListItem.vue';
import SearchBar from '@/components/next/SearchBar.vue';
import VoteButton from '../components/VoteButtonNew.vue';
import { voteList, getRule, getLimitInfo } from '../api';
import { List, Lazyload, Dialog, Toast } from 'vant';
import { wxSdkInfo } from '@/api/api';

Vue.use(List)
  .use(Lazyload)
  .use(Dialog)
  .use(Toast);
@Component({
  components: {
    VoteButton,
    SearchBar,
    ListItem,
  },
})
export default class Votes extends Vue {
  voteName: string = '2023project/q2/2023hlsqzdy_water';
  search = '';
  list: any[] = [];
  page = 1;
  loading = false;
  finished = false;
  loadingStatus = true;
  refreshing: boolean = false;
  show: boolean = true;
  content: string = '';
  maxvotelimit: number = 0;
  async onLoad() {
    const baseInfo = await getLimitInfo();
    this.maxvotelimit = parseInt(baseInfo.data.limitvote);
    const ret = await getRule();
    this.content = ret.data;
    voteList(this.page, this.search).then((res: any) => {
      this.endListData(res);
    });
  }
  endListData(res: any) {
    this.page = this.page + 1;
    if (res.data === '' || res.data.length === 0) {
      this.finished = true;
    } else {
      this.list = [...this.list, ...res.data];
    }
    this.loading = false;
  }
  onSearch() {
    this.finished = false;
    this.page = 1;
    this.list = [];
    this.show = false;
    setTimeout(() => {
      this.show = true;
    }, 500);
  }
  userInputChange(text: string) {
    this.search = text;
  }
  clear() {
    this.list = [];
    this.page = 1;
    this.finished = false;
  }
  // 获取微信sdk
  // wxConfig(statement: object) {
  //   window.wx.config({
  //     debug: false,
  //     ...statement,
  //     jsApiList: [
  //       // 所有要调用的 API 都要加到这个列表中
  //       'updateAppMessageShareData', // 分享到朋友
  //       'updateTimelineShareData', // 分享到朋友圈
  //       'onMenuShareAppMessage',
  //       'onMenuShareTimeline',
  //     ],
  //   });
  // }
  // @Watch('$route', { immediate: true })
  // onRouteChange() {
  //   console.log('进来的');
  //   // 设置分享文案
  //   const cover =
  //     'https://image2.cqcb.com/d/file/image/default/2023-07-27/696ab7633d167e862c836135947f0c3d.jpeg';
  //   // App分享

  //   const data = {
  //     title: '“欢乐社区总动员”首届水上趣味篮球赛最佳人气战队投票通道1',
  //     url: location.href,
  //     subtitle: `快来为“水BA”战队投票吧！`,
  //     classId: -1,
  //     id: -1,
  //     image: cover,
  //     type: 3,
  //   };
  //   setTimeout(() => {
  //     const option = {
  //       action: 'mSetShareInfo',
  //       data: JSON.stringify(data),
  //     };
  //     if (window.handleMessage) {
  //       window.handleMessage(JSON.stringify(option));
  //     }
  //   }, 500);
  //   // 微信分享
  //   if (isWeiXin()) {
  //     wxSdkInfo({ jssdkurl: window.location.href }).then((res: any) => {
  //       const data1 = res.data;
  //       const messageData = {
  //         title: '“欢乐社区总动员”首届水上趣味篮球赛最佳人气战队投票通道1', // 分享标题
  //         desc: `快来为“水BA”战队投票吧！`, // 分享描述
  //         link: location.href, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
  //         imgUrl:
  //           'https://image2.cqcb.com/d/file/image/default/2023-07-27/696ab7633d167e862c836135947f0c3d.jpeg', // 分享图标
  //       };
  //       this.wxConfig(data1);
  //       window.wx.ready(() => {
  //         window.wx.updateAppMessageShareData({
  //           ...messageData,
  //         });
  //         window.wx.updateTimelineShareData({
  //           ...messageData,
  //         });
  //       });
  //     });
  //   }
  // }
}
